export default __webpack_public_path__ + "static/avatar-mp-kayi-female-0-v2-cover-2cac358b85e4b83c4b9c64144822c40f.png";